import React from 'react';

export * as routes from './config/routes';

export default React.lazy(() => import('./Learning'));
export const QuizEdit = React.lazy(() => import('./Quiz/QuizEdit'));
export const QuizReview = React.lazy(() => import('./Quiz/QuizReview'));
export const Task = React.lazy(() => import('./Task'));